<template>
  <div>
    <v-simple-table
        class="table-layout border-table table-contact table-filter-contact"
        style="border: 0;"
        v-if="styleCountStatus === 1"
    >
      <template v-slot:default>
        <thead>
        <tr>
          <th
              class="font-weight-regular"
              rowspan="2"
              style="border-bottom: thin solid rgba(0, 0, 0, 0.12); cursor: pointer"
              @click="clickFilterStatus('all')"
              :class="isActive == 'all' ? 'active' : ''"
          >Xem tất cả</th>
          <th
              class="font-weight-regular"
              v-for="(type, index) in typeHeaderContactStatus"
              :key="'type-' + index"
              :colspan="getColSpan(type)"
          >
            <template v-if="typeContactExpand.includes(type.name)">
              <span @click="changeStatusExpand" style="cursor: pointer" class="font-weight-bold">
                <span v-if="!statusExpand">{{unescape('%3C')}} ... ></span>
                <span v-else>{{type.name}}</span>
              </span>
            </template>
            <template v-else>{{type.name}}</template>
          </th>
        </tr>
        <tr class="tr-contact-status">
          <th
              class="font-weight-regular"
              style="border-top: thin solid rgba(0, 0, 0, 0.12);"
              v-for="(contactStatus, index) in contactStatusList"
              :key="'name-type-' + index"
              v-show="!hideExpand(contactStatus)"
              v-bind:style="{ backgroundColor: getColorStatus(contactStatus.id), minWidth: (contactStatus.name.length*7 + 20) + 'px !important', padding: '0px 5px' }"
              :class="isActive == contactStatus.id ? 'active' : ''"
          >
            <template v-if="contactStatus.statusFirstTypeExpand && !statusExpand">...</template>
            <template v-else>
              <span @click="clickFilterStatus(contactStatus.id)" style="cursor: pointer;" >
                {{contactStatus.name}}
              </span>
            </template>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td style="min-width: 5rem;" :class="isActive == 'all' ? 'active' : ''">{{totalContactStatus}}</td>
          <td
              v-for="(contactStatus, index) in contactStatusList"
              :key="'noContact-' + index"
              v-show="!hideExpand(contactStatus)"
              :class="isActive == contactStatus.id ? 'active' : ''"
          >
            <template v-if="contactStatus.statusFirstTypeExpand && !statusExpand">...</template>
            <template v-else>{{contactStatus.noContact}}</template>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="second-bar" v-if="styleCountStatus === 2">
      <div>
        <div class="quick-filter-action" key="all"
             style="background-color: #D9D9D9; color: #E91E63"
             :class="isActive == 'all' ? 'active' : ''"
             @click="clickFilterStatus('all')">
          Tất cả
        </div>
        <div class="status-count-number" :class="isActive == 'all' ? 'active' : ''">{{ totalContactStatus }}</div>
      </div>
      <div v-for="option in contactStatusList" :key="option.id">
        <div class="quick-filter-action"
             :style="`background-color: ${option.color}; color: white`"
             :class="isActive == `${option.id}` ? 'active' : ''"
             @click="clickFilterStatus(option.id)">
          {{ option.name }}
        </div>
        <div class="status-count-number" :class="isActive == `${option.id}` ? 'active' : ''">{{option.noContact}}</div>
      </div>
    </div>
  </div>

</template>
<script>
import { typeContactExpand } from '@/helpers/constants';
export default {
  props: {
    filterForm: {
      type: Object,
      default: () => ({})
    },
    totalContactStatus: {
      type: Number,
      default: 0
    },
    styleCountStatus: {
      type: Number,
      default: 1
    },
    typeHeaderContactStatus: {
      type: Array,
      default: () => []
    },
    contactStatusList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      statusExpand: false,
      typeContactExpand,
      isActive: 'all'
    };
  },
  created() {
    this.isActive = this.filterForm.orderStatusId ? this.filterForm.orderStatusId : 'all';
  },
  methods: {
    clickFilterStatus(statusId) {
      if(statusId == 'all'){
        this.filterForm.orderStatusId = '';
        Bus.$emit('contact-list-filter', this.filterForm);
        this.isActive = statusId
      }
      else{
        this.filterForm.orderStatusId = statusId;
        Bus.$emit('contact-list-filter-by-contact-status', this.filterForm);
        this.isActive = statusId
      }
    },
    getColorStatus(statusId) {
      const dataStatus = this.contactStatusList.find(
          dataStatus => dataStatus.id == statusId
      );
      return _.get(dataStatus, 'color', '');
    },
    changeStatusExpand() {
      this.statusExpand = !this.statusExpand;
    },
    hideExpand(contactStatus) {
      if (!this.typeContactExpand.includes(contactStatus.type) || this.statusExpand) {
        return false;
      }
      return !contactStatus.statusFirstTypeExpand;
    },
    getColSpan(type) {
      if (!this.typeContactExpand.includes(type.name) || this.statusExpand) {
        return type.colspan;
      }
      return 1;
    },
    unescape(value) {
      return unescape(value);
    }
  }
};
</script>
<style lang="scss" scoped>
.active {
  font-weight: bold!important;
  font-size: 14px!important;
}

.tr-contact-status th {
  color: white !important;
}

.table-filter-contact {
  th {
    border-right: 1px solid #d2d2d2;
    height: 30px;
    &:last-child {
      border-right: 0;
    }
    td {
      position: relative;
      border-right: 1px solid #d2d2d2;
      &:last-child {
        border-right: 0;
      }
    }
  }
  td {
    padding-top: 0;
    padding-bottom: 0;
    height: 30px;
  }
  thead tr {
    height: 30px;
    th {
      font-size: $font-size-root - 2 !important;
      color: #000000;
      min-width: 65px !important;
    }
  }
  tbody {
    tr {
      height: 30px;
    }
  }
}
.second-bar {
  margin-top: 15px;
  min-height: 39px;
  min-width: 900px;
  border-radius: 0px;
  background: #FFFFFF;
  display: flex;
  justify-content: flex-start;
}

.quick-filter-action {
  max-height: 35px;
  border-radius: 0px;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  padding: 10px;
  margin-right: 1px;
  cursor: pointer;
}
.active {
  font-weight: bold!important;
  font-size: 16px!important;
}
.status-count-number{
  border: #d2d2d2 0.1px solid;
  text-align: center !important;
  font-style: normal;
  font-weight: 400 ;
  font-size: 16px;
  line-height: 16px;
  color: #333333 !important;
  padding: 5px;
}
</style>
